import styled from '@emotion/styled';
import { css } from '@emotion/react';

import { NavLink } from 'react-router-dom';

import { linkWithUnderlineHover } from 'styles/mixins';
import { breakpoints } from 'styles/basic';

import Container from 'components/Container';

interface ShowMenuProps {
  showMenu: boolean;
}

const Wrapper = styled.nav<ShowMenuProps>`
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 3;
  width: 30rem;
  padding: 2rem 0;
  background: ${(props) => props.theme.mainColors.primary};
  color: ${(props) => props.theme.colorMono.white};

  ${(props) => props.showMenu && css`
    display: block;
  `};
  ${(props) => !props.showMenu && css`
    display: none;

    @media (min-width: ${breakpoints.portraitTablet}) {
      display: block;
    }
  `};

  @media (min-width: ${breakpoints.portraitTablet}) {
    position: static;
    display: block;
    width: auto;
  }

  @media (min-width: ${breakpoints.smallLaptop}) {
    padding: ${(props) => props.theme.layout.padding} 0;
  }
`;

const StyledContainer = styled(Container)`
  position: relative;

  @media (min-width: ${breakpoints.portraitTablet}) {
    display: flex;
    align-items: center;
  }
`;

const ListWrapper = styled.div`
  & + & {
    margin-top: 1.5rem;
    padding-top: 1.5rem;
    border-top: .3rem solid ${(props) => props.theme.colorMono.black};
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    display: flex;
    align-items: center;
    & + & {
      margin-top: 0;
      padding-top: 0;
      border-top: 0;
      &::before {
        content: '/';
        display: block;
        margin: 0 3rem;
        font-weight: 600;
        color: ${(props) => props.theme.colorMono.black};
      }
    }
  }
`;

const List = styled.ul`
  margin: 0;
  list-style: none;

  @media (min-width: ${breakpoints.portraitTablet}) {
    display: flex;
    align-items: center;
  }
`;

const Item = styled.li`
  font-size: 1.8rem;
  font-weight: 500;
  text-transform: uppercase;
  & + & {
    margin-top: 1.5rem;
  }

  @media (min-width: ${breakpoints.portraitTablet}) {
    font-size: 1.4rem;
    & + & {
      margin-top: 0;
      margin-left: 3rem;
    }
  }

  @media (min-width: ${breakpoints.smallLaptop}) {
    font-size: 2rem;
  }
`;

const ItemLink = styled(NavLink)`
  ${(props) => linkWithUnderlineHover('&', 3, props.theme.mainColors.secondary)};

  &.active,
  &:active,
  &:hover {
    &::after {
      width: 100%;
    }
  }
`;

export {
  Wrapper,
  StyledContainer,
  ListWrapper,
  List,
  Item,
  ItemLink
};
